import React, { Component } from "react";
import classnames from "classnames";

import styles from "./HStack.scss";

export interface IHStackProps {
    className?: string;
    vAlign?: "top" | "bottom" | "center";
    hAlign?:
        | "start"
        | "end"
        | "center"
        | "space-around"
        | "space-between"
        | "space-evenly"
        | "stretch";
    innerSpacing?: "sm" | "md" | "lg";
    children?: React.ReactNode;
}

export class HStack extends Component<IHStackProps> {
    public render() {
        const { className, vAlign, hAlign, innerSpacing, children, ...props } =
            this.props;
        return (
            <div
                className={classnames(
                    styles.hstack,
                    vAlign && styles[`v-align-${vAlign}`],
                    hAlign && styles[`h-align-${hAlign}`],
                    innerSpacing && styles[`inner-spacing-${innerSpacing}`],
                    className,
                )}
                {...props}
            >
                {children}
            </div>
        );
    }
}
